import RankEleven from '@assets/icons/rank-eleven.svg'
import { Icon } from './Icon'

export const RankElevenIcon = Icon(RankEleven)
